<template>
  <div :class="wrapperClass">
    <AdvProgressBar
      :min="0"
      :max="transportThreshold"
      :current="cartTotal"
      progress-wrapper-class="minicart-progress-wrapper"
      progress-base-class="minicart-progress-base"
      progress-fill-class="minicart-progress-fill"
    >
      <div class="minicart-progress-logo-wrapper">
        <span class="minicart-progress-logo"></span>
      </div>
    </AdvProgressBar>
    <div class="alert-content text-black minicart-first-alert-content">
      {{ t('transport_cost_free_for_orders_above', { namespace: 'advCartDeliveryInfo', params: [{freeTransportCartLimit: transportThreshold, sign: currencySymbol}] }) }}
    </div>
    <div class="alert-content text-black mt-3 mb-2 minicart-second-alert-content">
      <div v-if="isEligibleForFreeDelivery" class="minicart-free-delivery-eligible">
        <Lottie
          ref="lottie"
          :animation-data="lottieFile"
          :auto-play="true"
          :loop="true"
          width="80px"
          height="80px"
        />
        <p class="delivery-progress-success">
          {{ t('congratulations', { namespace: 'advCartDeliveryInfo' }) }}
          {{ t('you_have_free_shipping', { namespace: 'advCartDeliveryInfo' }) }}
        </p>
      </div>
      <span v-else>{{ t('remaining_for_free_delivery', { namespace: 'advCartDeliveryInfo', params: [{remaining: remainingTotalForFreeDelivery, sign: currencySymbol}] }) }}</span>
    </div>
  </div>
</template>

<script>
import AdvProgressBar from './presentation/AdvProgressBar'
import Lottie from './Lottie.vue'
import lottieFile from '../lotties/miniCartSuccess.json'
export default {
  name: 'AdvCartDeliveryInfo',
  components: {
    AdvProgressBar,
    Lottie
  },
  props: {
    cartTotal: {
      type: [String, Number],
      default: 0
    },
    transportThreshold: {
      type: Number,
      default: 100
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    currencySymbol: {
      type: String,
      default: '€'
    }
  },
  computed: {
    isEligibleForFreeDelivery: function () {
      return this.cartTotal > this.transportThreshold
    },
    remainingTotalForFreeDelivery: function () {
      return (this.transportThreshold - this.cartTotal).toFixed(2)
    },
    lottieFile () {
      return lottieFile
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-cart-transport-message{
  background: transparent;
  padding: 0;
  color: black;
  font-size: 15px;
  line-height: 1.4;
  margin-bottom: 15px;
  .minicart-second-alert-content{
    font-weight: 700;
    margin-bottom:15px;
    span{
      color:var(--liolios-warning)
    }
  }

  .minicart-first-alert-content{
    margin-top:15px
  }
}
.minicart-free-delivery-eligible {
  display: grid;
  grid-template-columns: 80px auto;
  align-items: end;
  p {
    margin: 0
  }
}
.delivery-progress-success{
  color: #43C963
}
</style>
